import { render, staticRenderFns } from "./articleContent.vue?vue&type=template&id=280bdb22&scoped=true"
import script from "./articleContent.vue?vue&type=script&lang=js"
export * from "./articleContent.vue?vue&type=script&lang=js"
import style0 from "./articleContent.vue?vue&type=style&index=0&id=280bdb22&prod&lang=scss&scoped=true"
import style1 from "./articleContent.vue?vue&type=style&index=1&id=280bdb22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280bdb22",
  null
  
)

export default component.exports